module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "messagebox-wrapper-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "xigua-modal-dialog message-box-wrapper",
    class: {
      'xigua-modal-hidden': !_vm.showModal
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleWrapperClick($event)
      }
    }
  }, [_vm._t("message-box", [_c('div', {
    staticClass: "message-box",
    class: [_vm.customDefaultClass, _vm.messageBoxCustom],
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("header-wrapper", [(_vm.title !== undefined || true) ? _c('div', {
    staticClass: "xigua-modal-header"
  }, [_vm._t("title", [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleAction('cancel')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h3', {
    staticClass: "xigua-modal-title"
  }, [_vm._v(_vm._s(_vm.title))])])], 2) : _vm._e()]), _vm._v(" "), _vm._t("content-wrapper", [_c('div', {
    staticClass: "message-box-content"
  }, [_vm._t("content", [(_vm.type == 'alert_html' || _vm.type == 'msgbox_html') ? _c('div', {
    staticClass: "message-box-content-alert-text",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'confirm_html') ? _c('div', {
    staticClass: "message-box-content-confirm-text"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), _vm._t("prompt", [(_vm.type == 'prompt_html') ? _c('div', {
    staticClass: "message-box-content-prompt"
  }, [_c('div', {
    staticClass: "message-box-content-prompt-title"
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _vm._t("prompt-content", [_c('div', {
    staticClass: "message-box-content-prompt-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "message-box-content-prompt-content-input",
    attrs: {
      "autofocus": "autofocus",
      "placeholder": _vm.inputPlaceholder
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleAction('confirm')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message-box-content-prompt-content-errMessage",
    class: _vm.errorMessageClass
  }, [_vm._v(_vm._s(_vm.inputErrorMessage))])])])], 2) : _vm._e()]), _vm._v(" "), _vm._t("self")])], 2)]), _vm._v(" "), _vm._t("btns-wapper", [_c('div', {
    staticClass: "dialog-footer message-box-btns"
  }, [_vm._t("btns", [(_vm.showConfirmButton) ? _c('button', {
    staticClass: "message-box-confirm",
    class: [_vm.confirmButtonClass, _vm.buttonDisabledClass],
    attrs: {
      "disabled": _vm.confirmBtnDisabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleAction('confirm')
      }
    }
  }, [_vm._v(_vm._s(_vm.confirmButtonText))]) : _vm._e(), _vm._v(" "), (_vm.showCancelButton) ? _c('button', {
    class: [_vm.cancelButtonClass],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleAction('cancel')
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelButtonText))]) : _vm._e()])], 2)])], 2)])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0090e32c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messagebox-custom/message.box.vue
// module id = 581
// module chunks = 0